module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "visible": _vm.approvalVisiable,
      "center": true,
      "destroy-on-close": true,
      "close-on-click-modal": false,
      "custom-class": "approval_box"
    },
    on: {
      "update:visible": function($event) {
        _vm.approvalVisiable = $event
      }
    }
  }, [_c('span', {
    staticClass: "dialog-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [(_vm.type === 'approve') ? _c('span', [_c('i', {
    staticClass: "el-icon-success",
    staticStyle: {
      "font-size": "18px",
      "color": "#008748",
      "font-weight": "100"
    }
  }), _vm._v("\n      " + _vm._s(_vm.title || _vm.$t('popup.approve')) + "\n    ")]) : _c('span', [_c('i', {
    staticClass: "el-icon-error",
    staticStyle: {
      "font-size": "18px",
      "color": "#e40030",
      "font-weight": "100"
    }
  }), _vm._v("\n      " + _vm._s(_vm.title || _vm.$t('popup.reject')) + "\n    ")])]), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.changeRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "comment"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "resize": "none",
      "maxlength": "500",
      "placeholder": _vm.placeholder,
      "show-word-limit": ""
    },
    model: {
      value: (_vm.form.comment),
      callback: function($$v) {
        _vm.$set(_vm.form, "comment", $$v)
      },
      expression: "form.comment"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "round": "",
      "size": "medium",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.confirmApproval
    }
  }, [_vm._v(_vm._s(_vm.$t('btn.confirm')) + "\n    ")])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-45c4bd25", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45c4bd25","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/libs/approvalBox/index.vue
// module id = 1570
// module chunks = 7